import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClickTracking } from '../hooks/useClickTracking';
import { PRODUCTS } from '../utils/constants';
import { isMobileDevice } from '../utils/helpers';
import './SplitSection.css';

/**
 * SplitSection Component
 * Individual section of the split-screen landing page
 * On desktop: Shows title, subtitle, and button on hover
 * On mobile: Shows only the button (no hover effects)
 */
function SplitSection({ title, subtitle, imageSrc, href, side, isHovered, onHover, buttonText = 'Shop Now', imageSize, imagePosition, mobileImagePosition, showFullImage }) {
  const navigate = useNavigate();
  const { trackClick } = useClickTracking();
  const [isMobile, setIsMobile] = useState(false);

  // Check if mobile on mount
  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);

  const handleClick = async () => {
    // Determine product type from href
    const product = href === '/candy' ? PRODUCTS.CANDY : PRODUCTS.APPAREL;
    
    // Track the click
    await trackClick(product);
    
    // Navigate to the page
    navigate(href);
  };

  const handleTouchStart = () => {
    // Don't trigger hover on mobile
    if (!isMobile) {
      onHover(true);
    }
  };

  const handleTouchEnd = () => {
    // Don't trigger hover on mobile
    if (!isMobile) {
      onHover(false);
    }
  };

  // Determine state classes (no hover effects on mobile)
  let stateClass = '';
  if (!isMobile && isHovered !== null) {
    stateClass = isHovered ? 'hovered' : 'dimmed';
  }

  return (
    <div
      className={`split-section ${stateClass} ${showFullImage ? 'full-image-mode' : ''}`}
      onMouseEnter={() => !isMobile && onHover(true)}
      onMouseLeave={() => !isMobile && onHover(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onClick={handleClick}
      style={{
        ...(!showFullImage && { backgroundImage: `url(${imageSrc})` }),
        backgroundColor: '#0a0a0a',
        ...(!showFullImage && imageSize && { backgroundSize: imageSize }),
        ...(!showFullImage && (isMobile ? mobileImagePosition : imagePosition) && { backgroundPosition: isMobile && mobileImagePosition ? mobileImagePosition : imagePosition }),
      }}
    >
      {showFullImage && (
        <img src={imageSrc} alt={title} className="full-image" />
      )}
      <div className="overlay"></div>
      <div className="content">
        <h2 className="title">{title}</h2>
        <p className="subtitle">{subtitle}</p>
        <button className="shop-button">{buttonText}</button>
      </div>
    </div>
  );
}

export default SplitSection;
